import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UsersCard from "./UsersCard";
import { getUsersList, deleteUserListDetails } from "../Actions/UserManageAPI";
import axios from "axios";
import API, { postClient } from "../helpers/api";
import { toast } from "react-toastify";
import ClientUserCard from "./ClientUserCard";
import { confirmAlert } from "react-confirm-alert";
import { getClientManagementList, putClientUserDetails } from "../Actions/ClientManagementAPI";
import { withTranslation } from "react-i18next";
import "./UserManagementMaster.css";

let searchData = {
  CompanyName: '',
  Mail: '',
  Phone: '',
  ClientType: '',
  PageNumber: 1,
  PageSize: 20
}
let currentUser = JSON.parse(localStorage.getItem("currentUser"))
class ClientUserManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        CompanyName: '',
        Mail: '',
        Phone: '',
        ClientType: '',
        PageNumber: 1,
        PageSize: 20
      }
    }
    this.SearchUserList = this.SearchUserList.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getClientManagementList(this.state.searchData));
  }

  SearchUserList(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch(getClientManagementList(this.state.searchData));
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  ClearInput() {
    this.state.searchData.Mail = "";
    this.setState({});
  }

  eyeclick(item) {
    const { history } = this.props;
    history.push(`/Home/Management/EditClientUser/${item.clientId}`);
  }

  deleteUserList(item) {
    const { ClientUsersDetails, ClientDetails, history, dispatch ,t} = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
    let client = {
      clientId: item.clientId,
      companyName: item.companyName,
      mail: item.mail,
      address: item.address,
      telephone: item.telephone,
      clientType: item.clientType,
      isDeleted: true,
      modifiedBy: currentUser.name,
    }
    let url = `${API.getClientDetails}`;
    axios.put(url, client, {
      headers: {
        key: currentUser.accessToken
      }
    })
      .then((response) => {
        dispatch(putClientUserDetails(client));
        dispatch(getClientManagementList(searchData));
        dispatch({ type: "ShowSidePan", data: false });
        history.goBack();
        dispatch({
          type: "putClientDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "putClientDetailsFailure",
          error: "ERROR"
        })
      })
    }
  },
  {
    label: `${t("confirmAlertMessage.No")}`,
    onClick: () => { }
  }
]
});
  }

  NewitemNav = () => {
    this.props.history.push("/Home/Management/AddUser");
  };

  render() {
    const { showSidePane, ClientList,t } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className={this.state.showSidePane ? "col-lg-6" : "col-lg-12"}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}>{t('TopPaneContent.ClientUser')}</h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-2">
                        <div className="col-lg-6 m-auto">
                          <label className="form-label" >{t('MMPLUserManagementContent.EmailId')}</label><br></br>
                          <input className="form-control" type="text" name="Mail" value={this.state.searchData.Mail} placeholder={t('MMPLUserManagementContent.EmailId')} onChange={e => this.handleInputChange(e)}></input>
                        </div>
                        <div className="col-lg-6 m-auto">
                          <label className="mt-4"></label><br></br>
                          <div className="search-btn-col" style={{ textAlign: "end" }}>
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit" onClick={() => this.SearchUserList(1)}>
                              {" "} {t('content.Search')}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button" onClick={() => this.ClearInput()}>
                              {" "} {t('content.Clear')}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {ClientList ?
                <ClientUserCard
                  arraylist={ClientList.data}
                  pageSize={ClientList.pagination.pageSize}
                  totalRecords={ClientList.pagination.totalcount ? ClientList.pagination.totalcount : 0}
                  setUpdatedState={(value) => this.SearchUserList(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deleteUserList={(item) => this.deleteUserList(item)}
                />
                : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan,
    ClientList: state.MasterScreenReducer.ClientList,
    ClientDetails: state.MasterScreenReducer.ClientManagementDetails,
    ClientUsersDetails: state.MasterScreenReducer.ClientUsersDetails,
  }
}
export default withTranslation() (withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientUserManagement)));